module.exports = __webpack_public_path__ + "static/Commune-e395d92179fcf12ca31bcf5edebd6794.jpg";